/** Normalize access token from URL (?tkn= or ?token=), with or without "Bearer " prefix. */
export function normalizeUrlAccessToken(raw) {
  if (raw == null) return '';
  return String(raw).replace(/^Bearer\s+/i, '').trim();
}

/** Decode JWT payload; returns null if not a JWT-shaped string. */
export function decodeJwtPayload(accessToken) {
  const token = normalizeUrlAccessToken(accessToken);
  if (!token || token.split('.').length < 2) return null;
  try {
    return JSON.parse(atob(token.split('.')[1] || '{}'));
  } catch {
    return null;
  }
}

export function getUserIdFromJwtPayload(payload) {
  if (!payload || typeof payload !== 'object') return '';
  return String(
    payload.sub ?? payload.userId ?? payload.user_id ?? payload.id ?? ''
  ).trim();
}

export function isJwtExpiredPayload(payload) {
  const exp = payload?.exp;
  if (!exp) return false;
  return Date.now() >= Number(exp) * 1000;
}
